import { observer } from 'mobx-react-lite';
import { ConfirmPopup } from '../../../../components/common-components/pop-up/Popup';
import { useStore } from '../../../../hooks/useStore';
import styles from './DeleteOvertimeDialog.module.css';

const formatDateTime = (value?: string | Date) => {
  if (!value) {
    return '—';
  }

  return new Date(value).toLocaleString('tr-TR', {
    day: '2-digit',
    month: '2-digit',
    year: 'numeric',
    hour: '2-digit',
    minute: '2-digit',
  });
};

const DeleteOvertimeDialog = () => {
  const { popupStore, overtimeStore } = useStore();
  const overtime = overtimeStore.overtimeToDelete;

  const handleClose = () => {
    popupStore.setIsDeleteOvertimeConfirmationOpen(false);
    overtimeStore.setOvertimeToDelete(null);
  };

  const handleConfirm = async () => {
    if (!overtime?.id) {
      return;
    }

    await overtimeStore.deleteOvertime(overtime.id);
    handleClose();
  };

  const message = overtime ? (
    <div className={styles.content}>
      <p className={styles.message}>Aşağıdaki mesai kaydını silmek istediğinizden emin misiniz?</p>
      <ul className={styles.detailList}>
        <li className={styles.detailItem}>
          <span className={styles.detailLabel}>Kullanıcı</span>
          <span className={styles.detailValue}>{overtime.userName || '—'}</span>
        </li>
        <li className={styles.detailItem}>
          <span className={styles.detailLabel}>Tür</span>
          <span className={styles.detailValue}>
            {overtime.overtimeType === 'Overtime' ? 'Mesai' : 'İzin'}
          </span>
        </li>
        <li className={styles.detailItem}>
          <span className={styles.detailLabel}>Başlangıç</span>
          <span className={styles.detailValue}>{formatDateTime(overtime.startDate)}</span>
        </li>
        <li className={styles.detailItem}>
          <span className={styles.detailLabel}>Bitiş</span>
          <span className={styles.detailValue}>{formatDateTime(overtime.endDate)}</span>
        </li>
      </ul>
      <p className={styles.warning}>Bu işlem geri alınamaz.</p>
    </div>
  ) : (
    'Bu mesai kaydını silmek istediğinizden emin misiniz? Bu işlem geri alınamaz.'
  );

  const result = (
    <ConfirmPopup
      isOpen={popupStore.isDeleteOvertimeConfirmationOpen}
      onClose={handleClose}
      onConfirm={handleConfirm}
      intent="delete"
      title="Mesai Kaydı Silme Onayı"
      description="Silme işlemi kalıcıdır"
      message={message}
      closeOnConfirm={false}
    />
  );

  return result;
};

export default observer(DeleteOvertimeDialog);
